<script>
    import "./sidebar.css";
    import ConnectButton from "../ConnectButton.svelte";
    import {link} from 'svelte-spa-router';
    export let activeMenu = false;
</script>

<div class="sidebar-wrapper" class:active={activeMenu}>
<!--    <button class="btn-gradient-border">-->
<!--        <a href="/explore-projects" use:link>Explore Projects</a>-->
<!--    </button>-->
    <button class="btn-gradient-border">
        <a href="#/permissionless" use:link>Create Project</a>
    </button>
    <button class="btn-gradient-border">Social Hive</button>
    <button class="btn-gradient-border btn-start-project">Start a Project</button>
    <ConnectButton/>
</div>
